import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "ESHOPCONFIG_LIST_ERROR":
            return action.error;

        case "ESHOPCONFIG_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "ESHOPCONFIG_LIST_LOADING":
            return action.loading;

        case "ESHOPCONFIG_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case "ESHOPCONFIG_LIST_SUCCESS":
            return action.retrieved;

        case "ESHOPCONFIG_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved});
